import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function NoCreditCheckLoan() {
    return (
        <div>
            <Seo
                title="Prêt rapide sans enquête de crédit | Trouvez les meilleures offres au Québec | Argent Aujourd’hui"
                description="Comparez les prêts sans enquête de crédit sur notre site et choisissez l'option idéale pour vos besoins financiers. Accédez aux meilleures offres."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt rapide sans enquête de crédit</h1>

                    <p className="header-subtitle">
                        Vous cherchez un prêt rapide et sans vérification de crédit? Obtenez un
                        financement en quelques clics grâce à Argent Aujourd’hui! Découvrez notre
                        comparateur en ligne pour bénéficier de prêts sans enquête de crédit au
                        Québec. Un processus simple, fiable et confidentiel.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="Situation-steps">
                <div className="content" data-aos="fade-up">
                    <h2 className="sect-title">
                        3 étapes pour obtenir votre prêt sans enquête de crédit
                    </h2>

                    <p className="sect-subtitle">
                        Pour bénéficier de prêts rapides sans enquête de crédit, Argent Aujourd’hui
                        compare pour vous les meilleures options du marché! Obtenez un prêt
                        personnel en seulement 3 étapes :
                    </p>

                    <ol style={{ marginTop: 50 }}>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:note" width="40" />
                            </div>
                            <h3>Comparez nos offres en ligne</h3>
                            <p>
                                Pour connaître vos options de prêts sans enquête de crédit,
                                commencez par remplir notre{' '}
                                <Link to="/new-lead">formulaire de demande en ligne</Link>. Nous
                                vous proposons ensuite les options de prêts rapides du Québec
                                adaptées à vos besoins. Chaque institution a ses propres montants,
                                délais et tarifs, prenez le temps de comparer leurs offres pour
                                choisir celle qui sera la plus avantageuse pour vous.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:home" width="40" />
                            </div>
                            <h3>Faites votre demande de prêt </h3>
                            <p>
                                Une fois que vous avez choisi une institution financière, cliquez
                                simplement sur son nom pour commencer la procédure. Vous serez
                                automatiquement dirigés vers leur formulaire de demande de prêt sans
                                enquête de crédit. Vous devrez leur renseigner vos informations
                                personnelles, dont une pièce d'identité valide. Cette étape permet
                                au prêteur d’évaluer rapidement votre demande.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:paper-plane" width="40" />
                            </div>
                            <h3>Recevez votre prêt en 24h</h3>
                            <p>
                                Après avoir reçu votre demande, le prêteur effectuera une{' '}
                                <b>vérification bancaire bancaire instantanée</b> (technologie IBV)
                                afin de déterminer votre capacité de remboursement. Si votre demande
                                est approuvée, vous pourrez recevoir votre prêt dans les 24 heures
                                suivantes!
                            </p>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Autres avantages de notre prêt sans enquête de crédit
                    </h2>

                    <p className="sect-subtitle">
                        Pour obtenir des prêts immédiats, Argent Aujourd’hui vous offre une vitrine
                        détaillée des options de financement à votre disposition. En quelques clics,
                        obtenez un choix de prêts sans enquête de crédit, disponibles rapidement. En
                        plus de vous offrir un <b>service entièrement gratuit et sans engagement</b>
                        , Argent Aujourd’hui c’est aussi une démarche :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Efficace</h4>

                            <span style={{ marginTop: 130 }}>
                                Nous sélectionnons pour vous les institutions qui offrent une
                                approbation rapide et effectuent des prêts par virement interac
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Sécuritaire</h4>

                            <span style={{ marginTop: 130 }}>
                                Nous travaillons uniquement avec des institutions financières
                                québécoises vérifiées
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Sans vérification de crédit</h4>

                            <span style={{ marginTop: 130 }}>
                                Nos partenaires effectuent des prêts IBV.
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Qu’est-ce qu'une enquête de crédit?</h2>

                    <p className="sect-subtitle">
                        Une enquête de crédit est un processus utilisé par diverses institutions
                        financières pour examiner votre dossier de crédit personnel. Elle permet d'
                        <b>
                            évaluer votre historique de crédit, votre capacité de remboursement
                        </b>{' '}
                        basée sur vos revenus, ainsi que d’autres renseignements financiers. Au
                        Québec et au Canada, ces enquêtes sont généralement effectuées auprès des
                        agences de crédit comme{' '}
                        <a href="https://www.equifax.ca" target="_blank" rel="noreferrer">
                            Equifax
                        </a>{' '}
                        ou{' '}
                        <a href="https://www.transunion.ca" target="_blank" rel="noreferrer">
                            TransUnion
                        </a>
                        .
                    </p>

                    <p className="sect-subtitle">
                        Les institutions de prêt traditionnelles se basent sur ces informations pour
                        déterminer votre solvabilité. À l’inverse,{' '}
                        <b>
                            un prêt sans enquête de crédit ne prend pas en compte votre historique
                        </b>{' '}
                        et n’a aucun impact sur votre cote de crédit! C’est une solution alternative
                        avantageuse pour accéder rapidement à des fonds, quelle que soit votre
                        situation.
                    </p>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Qu’est-ce qu’une mauvaise cote de crédit?</h2>

                    <p className="sect-subtitle">
                        Pour vérifier votre solvabilité, les agences de crédit déterminent une note
                        de crédit sur une échelle de 300 à 900. Celle-ci est calculée en fonction de
                        votre historique et détermine votre capacité de remboursement. Une{' '}
                        <b>cote en dessous de 600 est considérée comme faible</b> et peut rendre
                        l’accès aux prêts avec votre banque plus difficile, voire entraîner des
                        refus de financement.
                    </p>

                    <p className="sect-subtitle">
                        En cas de mauvais crédit ou d’absence d’antécédents, la{' '}
                        <b>vérification bancaire instantanée (prêt IBV)</b> permet aux prêteurs
                        alternatifs de déterminer votre capacité de remboursement sans passer par
                        votre cote de crédit.
                    </p>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Choisissez le montant dont vous avez besoin!</h2>

                    <p className="sect-subtitle">
                        Quelle que soit votre situation, Argent Aujourd'hui compare pour vous les
                        options de financement adaptées à vos besoins :
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 100$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 200$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>

                    <p className="sect-subtitle">
                        Vous aimeriez obtenir un prêt sans enquête de crédit rapidement? Comparez
                        les meilleures offres du marché dès aujourd'hui!
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            {/* <ClientsBanner /> */}

            <Footer />
        </div>
    )
}
